import React, { useEffect, useState } from 'react';

var back = true;
var countNumber = 0;
var arrayPossition = 0;

const TypeWrite = ({ values }: { values: string[] }) => {
    const [text, setText] = useState('');

    const typeWrite = (i = 0) => {

        if (i === values[arrayPossition].length && back) {
            back = false;
            countNumber = countNumber + 1;
        } else if (i === 0 && !back) {
            back = true;
            countNumber = countNumber + 1;
        };

        const timer = i + 1 === values[arrayPossition].length && back ? 1000 : 50;

        const count = back ? i + 1 : i - 1;

        setText(values[arrayPossition].slice(0, count));
        
        setTimeout(() => {
            if (countNumber === 2) {
                countNumber = 0;
                arrayPossition = arrayPossition + 1 < values.length
                    ? arrayPossition + 1
                    : 0;
            }
            typeWrite(count);
        }, timer)


    }

    useEffect(() => {
        typeWrite()
    }, []) // eslint-disable-line

    return (
        <h1>
            {text} |
        </h1>
    );
}

export default TypeWrite;